export const formatFriendlyDate = (dateString: string): string => {
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short", // Mon, Tue,
    month: "short", // Jan, Feb,
    day: "2-digit", // 08, 15,
    year: "numeric", // 2024
    hour: "2-digit", // 4 PM
    minute: "2-digit", // 30
    hour12: true, // AM/PM format
  }).format(new Date(dateString));
};

export const formatDate = (dateString?: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);

  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};
